<template>
  <div class="m-feed-section-content-footer">
    <span>Vidroop.com © {{ $moment().year() }}</span>
  </div>
</template>

<script>
export default {
  name: 'MoleculeFeedSectionContentFooter'
}
</script>
